import moment from "moment";

export const DUE_TYPES = {
    OVERDUE: "overdue",
    TODAY: "today",
    TOMORROW: "tomorrow",
    NEXT_7_DAYS: "next7Days"
};

/**
 * Categorize tasks by due date
 * @param {Array} tasks
 * @returns {Object} categorized tasks
 */
export function categorizeTasks(tasks = []) {
    console.log(16, "🚀 ~ categorizeTasks ~ tasks:", tasks)
    const result = {
        [DUE_TYPES.OVERDUE]: [],
        [DUE_TYPES.TODAY]: [],
        [DUE_TYPES.TOMORROW]: [],
        [DUE_TYPES.NEXT_7_DAYS]: []
    };

    const startOfToday = moment().startOf("day");
    const endOfToday = moment().endOf("day");
    const startOfTomorrow = moment().add(1, "day").startOf("day");
    const endOfTomorrow = moment().add(1, "day").endOf("day");
    const startOfNext7 = moment().add(2, "day").startOf("day");
    const endOfNext7 = moment().add(7, "day").endOf("day");

    for (const task of tasks) {
        if (!task?.end_date) continue;
        const dueDate = moment(task.end_date);

        if (dueDate.isBefore(startOfToday)) {
            result[DUE_TYPES.OVERDUE].push(task);
        } else if (dueDate.isBetween(startOfToday, endOfToday, null, "[]")) {
            result[DUE_TYPES.TODAY].push(task);
        } else if (dueDate.isBetween(startOfTomorrow, endOfTomorrow, null, "[]")) {
            result[DUE_TYPES.TOMORROW].push(task);
        } else if (dueDate.isBetween(startOfNext7, endOfNext7, null, "[]")) {
            result[DUE_TYPES.NEXT_7_DAYS].push(task);
        }
    }

    return result;
}

/**
 * Extract unique tasks from categorized groups
 * @param {Object} categorizedTasks
 * @returns {Array} uniqueTasks
 */
export function extractUniqueTasks(categorizedTasks) {
    console.log("🚀 ~ extractUniqueTasks ~ categorizedTasks:", categorizedTasks)
    const seen = new Set();
    const uniqueTasks = [];

    for (const key in categorizedTasks) {
        const tasks = categorizedTasks[key] || [];
        for (const task of tasks) {
            if (!task?._id) continue;
            if (!seen.has(task._id)) {
                seen.add(task._id);
                uniqueTasks.push(task);
            }
        }
    }

    return uniqueTasks;
}
